import * as React from 'react';
import { TPAComponentProps } from '../../types';
import { TextType } from '../Avatar/types';

export interface AvatarGroupItem {
  name?: string;
  src?: string;
  onLoad?: React.EventHandler<React.SyntheticEvent>;
  lettersLimit?: 1 | 2;
  'data-hook'?: string;
}

export enum AvatarGroupSize {
  xLarge = 'xLarge',
  large = 'large',
  medium = 'medium',
  small = 'small',
  xSmall = 'xSmall',
  xxSmall = 'xxSmall',
}

export interface AvatarGroupProps extends TPAComponentProps {
  children?: React.ReactNode;
  /** Array of Avatar items. Optional. Avatar item structure: {name?: 'Username', src?: 'https://link-to-image'}. All fields are optional. */
  items?: AvatarGroupItem[];
  /** Max amount of items shown in summary. Optional. Defaults to 5. */
  maxAmount?: number;
  /** Avatar's size. Optional. Dafaults to 'medium'. One of 'large' | 'medium' | 'small' | 'xSmall' | 'xxSmall'. */
  size?: AvatarGroupSize;

  /** Shows hidden avatars count indication */
  showHiddenAvatarCount?: boolean;
}

export interface AvatarGroupBaseProps extends TPAComponentProps {
  id?: string;
  items: AvatarGroupItem[];
  maxAmount?: number;
  renderHiddenAvatarCount?: (
    avatarProps: AvatarGroupItem & { textType?: TextType },
    isHiddenAvatarIndication?: boolean,
  ) => React.JSX.Element;
  renderAvatar(avatarProps: AvatarGroupItem): React.JSX.Element;
  avatarContainerClassName: string;
}

export interface AvatarGroupDefaultProps {
  items: AvatarGroupItem[];
  maxAmount: number;
  size: AvatarGroupSize;
  showHiddenAvatarCount: boolean;
}
